
var React = require("react");
var EditorLaunchUtil = require("../../util/EditorLaunchUtil.js");

class Iframe extends React.Component {

    constructor(){
        super();

    }

    componentDidMount(){
    }

    shouldComponentUpdate() {
        return true;
    }

    getIframe(base, id, version) {
        let src = EditorLaunchUtil.editorUrl(base, { id: id, version: version, mode: 1 });
        return {__html: `<iframe src="${src}"></iframe>`}
    }

    render() {
        let {
            base,
            id,
            version
        } = this.props;

        return  <div className="contFrame" ref={f => this.iframe = f}>
                    <div style={this.props.style} dangerouslySetInnerHTML={ this.getIframe(base, id, version) }/>
                </div>
    }
};

module.exports = Iframe;
